import type { CreateOneShopExportDto, ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UpdateExportMethodParams = {
  shopExport: CreateOneShopExportDto;
  exportId: string;
};

type UseUpdateExportMethodParams = {
  onSuccess?: () => void;
};

export default function useUpdateExportMethod(
  shop: ShopDto,
  params?: UseUpdateExportMethodParams,
) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/exports/{exportId}",
    {
      invalidate: invalidateShop,
      onSuccess: () => {
        params?.onSuccess?.();
      },
      mapVariables: ({ shopExport, exportId }: UpdateExportMethodParams) => ({
        params: { path: { shopId: shop.id, exportId } },
        body: shopExport,
      }),
    },
  );
}
